import React from 'react';
import SEO from '../components/seo';
import { graphql } from 'gatsby';
// import { StaticImage } from 'gatsby-plugin-image';
// import Img from 'gatsby-image';

export default ({ data }) => {
  const post = data.allWpPost.nodes[0];
  return (
    <>
      {/* <SEO title={post.title} /> */}
      <section className="newsVisual">
        <h1 className="visual--title">News</h1>
      </section>
      <section className="newsSingle--title">
        <div className="infoWrap">
          <div className="infoWrap__date">{post.date} </div>
          {/* <div className="infoWrap__category">{post.categories[0].name}</div> */}
        </div>
        <h1>{post.title}</h1>
      </section>
      <article className="newsSingle--inner">
        {/* <div className="imageThumbnail">
        </div> */}
        <div className="newsText">
          {/* <StaticImage
            fluid={node.featuredImage.node.localFile.childImageSharp.fluid}
            alt={node.title}
            placeholder="blurred"
          /> */}
          <div dangerouslySetInnerHTML={{ __html: post.content }} />
        </div>
      </article>
    </>
  );
};
export const query = graphql`
  query($slug: String!) {
    allWpPost(filter: { slug: { eq: $slug } }) {
      nodes {
        title
        content
        featuredImage {
          node {
            localFile {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_withWebp_tracedSVG
                }
              }
            }
          }
        }
        slug
        date(formatString: "MMMM DD, YYYY")
        categories {
          nodes {
            name
          }
        }
      }
    }
  }
`;
